<template>
	<div>
		<button class="btn btn-secondary" @click="showSample = true">Шаблоны</button>
	</div>
	<AnimatedModal v-if="showSample" :open="showSample" @close="showSample = false">
		<template v-slot:header> Шаблоны </template>
		<template v-slot:body>
			<ul>
				<li v-for="isample of sampleTreeSorted" :key="isample.id">
					<input type="text" v-if="isample.name.edit !== null" v-model="isample.name.edit" />
					<a href="#" v-if="isample.name.edit === null" @click.prevent="applySample(isample)">{{
						isample.name.value
					}}</a>
					<button class="btn btn-secondary" v-if="isample.name.edit !== null" @click="saveSample(isample)">
						<span class="fa fa-check"></span>
					</button>
					<button class="btn btn-secondary" v-if="isample.name.edit !== null" @click="cancelSample(isample)">
						<span class="fa fa-ban"></span>
					</button>
					<button class="btn btn-secondary" v-if="isample.name.edit === null" @click="editSample(isample)">
						<span class="fa fa-pencil"></span>
					</button>
					<button class="btn btn-danger" @click="deleteSample(isample)"><span class="fa fa-remove"></span></button>
				</li>
			</ul>
		</template>
	</AnimatedModal>
	<AnimatedModal v-if="newSample" :open="!!newSample" @close="newSample = null">
		<template v-slot:header> Создание шаблона </template>
		<template v-slot:body>
			<div class="form-group">
				<label class="form-label">Название</label>
				<input type="text" class="form-control" v-model="newSample.name.edit" />
			</div>
		</template>
		<template v-slot:footer>
			<button class="modal-default-button btn btn-primary" @click="saveSample(newSample)">Сохранить</button>
			<button class="modal-default-button btn btn-secondary" @click="newSample = null">Отмена</button>
		</template>
	</AnimatedModal>
</template>
<script lang="ts" setup>
import { clone, createObject, type AnyType } from '@/lib/helpers';
import { getRectangle } from '@/lib/pack';
import { computed, inject, type PropType } from 'vue';
import { ref } from 'vue';
import { getRectangles, getSourceMaterialsFlat, newSample, setPack } from './common';
import AnimatedModal from '@/components/AnimatedModal.vue';

const jsParams = inject('jsParams') as AnyType;

const showSample = ref(false);
const sampleTree = ref<AnyType[]>([]);

const props = defineProps({
	settings: {
		type: Object as PropType<AnyType>,
		required: true,
	},
});

function editSample(sample: AnyType) {
	sample.name.edit = sample.name.value;
}
function saveSample(sample: AnyType) {
	if (!sample.name.edit) {
		return;
	}
	const data: AnyType = { sample: { id: sample.id, name: sample.name.edit } };
	if (!sample.id) {
		data['sample']['dataSettings'] = props.settings;
		data['sample']['dataRectangles'] = getRectangles();
		data['sample']['dataMaterials'] = getSourceMaterialsFlat();
	}
	fetch('./?model=packSample&action=update', {
		credentials: 'same-origin',
		method: 'POST',
		body: JSON.stringify(data),
	})
		.then(function (response) {
			return response.json();
		})
		.then(response => {
			if (response['sample']) {
				sample.name.value = response['sample']['name'];
				sample.name.edit = null;
				if (response['sample']['id']) {
					if (response['sample']['dataSettings'] !== undefined) {
						sample.dataSettings = response['sample']['dataSettings'];
					}
					if (response['sample']['dataRectangles'] !== undefined) {
						sample.dataSettings = response['sample']['dataRectangles'];
					}
					if (response['sample']['dataMaterials'] !== undefined) {
						sample.dataSettings = response['sample']['dataMaterials'];
					}
					sample.id = response['sample']['id'];
					sampleTree.value.push(sample);
				}
				newSample.value = null;
			}
		});
}
function cancelSample(sample: AnyType) {
	sample.name.edit = null;
}
function deleteSample(sample: AnyType) {
	if (!confirm('Удалить шаблон?')) {
		return;
	}
	fetch('./?model=packSample&action=delete&id=' + sample.id, {
		credentials: 'same-origin',
		method: 'POST',
	})
		.then(function (response) {
			return response.json();
		})
		.then(response => {
			const sampleId = response['sampleId'];
			if (sampleId) {
				for (let i = 0; i < sampleTree.value.length; i++) {
					if (sampleTree.value[i].id == sampleId) {
						sampleTree.value.splice(i, 1);
						break;
					}
				}
			}
		});
}
function applySample(sample: AnyType) {
	// deep clone
	const dataSettings = JSON.parse(JSON.stringify(sample.dataSettings));
	const rawDataRectangles = JSON.parse(JSON.stringify(sample.dataRectangles));
	const dataMaterials = JSON.parse(JSON.stringify(sample.dataMaterials));

	// конвертация прямоугольников старого формата
	const dataRectangles = [];
	for (let dataRectangle of rawDataRectangles) {
		if (!dataRectangle) {
			continue;
		}
		if (dataRectangle.constructor === Array) {
			dataRectangle = getRectangle(
				dataRectangle[0],
				dataRectangle[1],
				dataRectangle[2],
				dataRectangle[3],
				dataRectangle[4],
			);
		}
		dataRectangles.push(dataRectangle);
	}

	const settings = createObject(clone(props.settings), dataSettings, true);

	setPack(settings, dataRectangles, dataMaterials);

	showSample.value = false;
}

const sampleTreeSorted = computed(() => {
	const _sampleTree = sampleTree.value;
	_sampleTree.sort(function (item1: AnyType, item2: AnyType) {
		const field1 = (item1.name && item1.name.value) || null;
		const field2 = (item2.name && item2.name.value) || null;
		if (field1 < field2) return -1;
		else if (field1 > field2) return 1;
		return 0;
	});
	return _sampleTree;
});

const prepareSampleTree = function (sampleTree: AnyType) {
	const v = function (value: AnyType): AnyType {
		return { value: value, edit: null };
	};
	if (!sampleTree) {
		sampleTree = [];
	}
	return sampleTree.map(function (sample: AnyType) {
		sample.name = v(sample.name);
		return sample;
	});
};
sampleTree.value = prepareSampleTree(jsParams['sampleTree']);
</script>
